import React from 'react';
import { Link } from 'react-router-dom';
import {
  Phone,
  Mail,
  Globe,
  MapPin,
  Facebook,
  Instagram,
  Youtube,
  Twitter
} from 'lucide-react';

const Footer = () => {
  return (
    <footer className="web-footer-bar" style={{ background: '#ffffff', color: '#475569', borderTop: '1px solid #e2e8f0', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <div className="web-footer-container">
        
        <div className="footer-main-grid">
          
          {/* Brand Info Column */}
          <div>
            <Link to="/" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '2px', width: '22px' }}>
                {[...Array(9)].map((_, i) => (
                  <div key={i} style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#dc2626' }}></div>
                ))}
              </div>
              <div>
                <span style={{ fontSize: '18px', fontWeight: 900, color: '#0f172a', letterSpacing: '-0.02em', display: 'block', lineHeight: 1 }}>INFRAEDGE</span>
                <span style={{ fontSize: '9px', fontWeight: 800, color: '#dc2626', letterSpacing: '0.1em' }}>RED LIGHT THERAPY</span>
              </div>
            </Link>

            <p style={{ fontSize: '13px', color: '#64748b', lineHeight: 1.6, marginBottom: '20px' }}>
              Heal Smarter, Live Better. Advanced Red Light Therapy solutions designed for peak recovery and cellular vitality.
            </p>

            {/* Certification Badges */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px' }}>
              <span style={{ border: '1px solid #cbd5e1', background: '#f8fafc', padding: '4px 10px', borderRadius: '4px', fontSize: '11px', fontWeight: 900, color: '#0f172a' }}>UK CA</span>
              <span style={{ border: '1px solid #cbd5e1', background: '#f8fafc', padding: '4px 10px', borderRadius: '4px', fontSize: '11px', fontWeight: 900, color: '#0f172a' }}>CE</span>
            </div>

            {/* Social Icons */}
            <div style={{ display: 'flex', gap: '10px' }}>
              <div style={{ width: '34px', height: '34px', borderRadius: '50%', background: '#f1f5f9', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0f172a', cursor: 'pointer' }}>
                <Facebook size={15} />
              </div>
              <div style={{ width: '34px', height: '34px', borderRadius: '50%', background: '#f1f5f9', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0f172a', cursor: 'pointer' }}>
                <Instagram size={15} />
              </div>
              <div style={{ width: '34px', height: '34px', borderRadius: '50%', background: '#f1f5f9', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0f172a', cursor: 'pointer' }}>
                <Youtube size={15} />
              </div>
              <div style={{ width: '34px', height: '34px', borderRadius: '50%', background: '#f1f5f9', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0f172a', cursor: 'pointer' }}>
                <Twitter size={15} />
              </div>
            </div>
          </div>

          {/* SHOP Column */}
          <div>
            <h4 style={{ fontSize: '12px', fontWeight: 900, color: '#0f172a', letterSpacing: '0.08em', marginBottom: '16px', textTransform: 'uppercase' }}>SHOP</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '13px' }}>
              <li><Link to="/shop" style={{ color: '#64748b', textDecoration: 'none', fontWeight: 600 }}>All Products</Link></li>
              <li><Link to="/shop" style={{ color: '#64748b', textDecoration: 'none', fontWeight: 600 }}>Mini Panels (72pcs)</Link></li>
              <li><Link to="/shop" style={{ color: '#64748b', textDecoration: 'none', fontWeight: 600 }}>5W Panels (144pcs)</Link></li>
              <li><Link to="/shop" style={{ color: '#64748b', textDecoration: 'none', fontWeight: 600 }}>Pro Panels (144pcs)</Link></li>
              <li><Link to="/shop" style={{ color: '#64748b', textDecoration: 'none', fontWeight: 600 }}>Max Panels (288pcs)</Link></li>
            </ul>
          </div>

          {/* COMPANY Column */}
          <div>
            <h4 style={{ fontSize: '12px', fontWeight: 900, color: '#0f172a', letterSpacing: '0.08em', marginBottom: '16px', textTransform: 'uppercase' }}>COMPANY</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '13px' }}>
              <li><Link to="/about" style={{ color: '#64748b', textDecoration: 'none', fontWeight: 600 }}>About Us</Link></li>
              <li><Link to="/science" style={{ color: '#64748b', textDecoration: 'none', fontWeight: 600 }}>Our Science</Link></li>
              <li><Link to="/contact" style={{ color: '#64748b', textDecoration: 'none', fontWeight: 600 }}>Contact Us</Link></li>
            </ul>
          </div>

          {/* SUPPORT Column */}
          <div>
            <h4 style={{ fontSize: '12px', fontWeight: 900, color: '#0f172a', letterSpacing: '0.08em', marginBottom: '16px', textTransform: 'uppercase' }}>SUPPORT</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '13px' }}>
              <li><Link to="/faq" style={{ color: '#64748b', textDecoration: 'none', fontWeight: 600 }}>FAQ</Link></li>
              <li><Link to="/contact" style={{ color: '#64748b', textDecoration: 'none', fontWeight: 600 }}>Support Center</Link></li>
              <li><Link to="/shipping" style={{ color: '#64748b', textDecoration: 'none', fontWeight: 600 }}>Shipping & Tracking</Link></li>
              <li><Link to="/returns" style={{ color: '#64748b', textDecoration: 'none', fontWeight: 600 }}>Returns & Refunds</Link></li>
              <li><Link to="/warranty" style={{ color: '#64748b', textDecoration: 'none', fontWeight: 600 }}>2 Year Warranty</Link></li>
            </ul>
          </div>

          {/* GET IN TOUCH Column */}
          <div>
            <h4 style={{ fontSize: '12px', fontWeight: 900, color: '#0f172a', letterSpacing: '0.08em', marginBottom: '16px', textTransform: 'uppercase' }}>GET IN TOUCH</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '13px' }}>
              <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Phone size={15} color="#dc2626" />
                <a href="tel:01214556529" style={{ color: '#0f172a', textDecoration: 'none', fontWeight: 800 }}>0121 455 6529</a>
              </li>
              <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Mail size={15} color="#dc2626" />
                <a href="mailto:Info@infraedgeredlight.co.uk" style={{ color: '#64748b', textDecoration: 'none' }}>Info@infraedgeredlight.co.uk</a>
              </li>
              <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Globe size={15} color="#dc2626" />
                <a href="https://activeacademy.co.uk/red-light-infrared-therapy" target="_blank" rel="noreferrer" style={{ color: '#64748b', textDecoration: 'none' }}>www.activeacademy.co.uk</a>
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                <MapPin size={16} color="#dc2626" style={{ flexShrink: 0, marginTop: '2px' }} />
                <span style={{ color: '#64748b', lineHeight: 1.4 }}>273 Hagley Road Edgbaston, Birmingham B16 9NB</span>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Copyright Row */}
        <div className="footer-bottom-row">
          <span>© 2026 InfraEdge Red Light Therapy. All rights reserved.</span>
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
            <Link to="/privacy" style={{ color: '#64748b', textDecoration: 'none' }}>Privacy Policy</Link>
            <Link to="/terms" style={{ color: '#64748b', textDecoration: 'none' }}>Terms of Service</Link>
            <Link to="/admin" style={{ color: '#dc2626', textDecoration: 'none', fontWeight: 800 }}>Admin Portal</Link>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
